<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Assign PDA Module Access</strong>
          </div>

          <b-row>
            <b-col md="12" class="my-1 text-center" style="color:#20a8d8;">
              <h4>Please Select PDA Module Assign Access</h4>
            </b-col>
          </b-row>

          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">

            <b-row>
              <b-col md="5" class="my-1">

                <!-- Select All -->
                <label>
                  <input type="checkbox" v-model="isCheckAll" @click="checkAll">
                  Select All
                </label>

                <!-- Menu List -->
                <ul>
                  <li v-for="(menu, index) in data" :key="index">

                    <label>
                      <input
                        type="checkbox"
                        :value="menu"
                        v-model="menusarr"
                        @change="updateParent($event, menu)"
                      >
                      {{ menu.title }}
                    </label>

                  </li>
                </ul>

              </b-col>

              <b-col md="2">
                <b-button variant="outline-dark" @click="resetAccess">Reset</b-button>
                <b-button class="ml-2" variant="outline-danger" @click="clearAccess">Clear</b-button>
              </b-col>

            </b-row>

            <b-row>
              <b-col md="12" class="my-2">
                <b-button type="submit" variant="primary">Save</b-button>
              </b-col>
            </b-row>

          </b-form>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'

export default {
  name: 'pdaaccess',

  data () {
    return {
      loader: false,
      data: [],
      menusarr: [],
      isCheckAll: false,
      id: '',
      userType: ''
    }
  },

  created () {
    this.id = this.$route.params.id;
    this.isquickuser = this.$route.query.is_qwik_user

    this.displayData()
  },

  methods: {

    /* ---------------- LOAD DATA ---------------- */
    displayData () {

      const obj = {
        sysusermasterid: this.id
      }

      this.$http.post(
        `${CONSTANTS.MISREPORT_API_URL}/accessPDAMenuList`,
        obj
      )
      .then((result) => {
        this.loader = false

        if (result.body.returnmsg === 'Successful') {
          this.data = result.body.returnvalue[0].pdabody

          const allocatedata = result.body.user_aceess_listing[0].pdabody || []

        //   this.menusarr = allocatedata

        this.menusarr = allocatedata.filter(item => item.active === 'Yes')


          this.isCheckAll = this.data.length > 0 &&
                             this.menusarr.length === this.data.length
        } else {
          this.data = []
        }
      })
      .catch((err) => {
        this.loader = false
        console.log('error', err)
      })
    },

    /* ---------------- CHECK ALL ---------------- */
    checkAll () {
      this.isCheckAll = !this.isCheckAll

      this.menusarr = []

      if (this.isCheckAll) {
        this.data.forEach(menu => {
          this.menusarr.push(menu)
        })
      }
    },

    /* ---------------- SINGLE CHECK ---------------- */
    updateParent (event, menu) {
      if (!event.target.checked) {
        this.isCheckAll = false
        return
      }

      if (this.menusarr.length === this.data.length) {
        this.isCheckAll = true
      }
    },

    /* ---------------- RESET ---------------- */
    resetAccess () {
      this.menusarr = []
      this.isCheckAll = false
      this.displayData()
    },

    /* ---------------- CLEAR ---------------- */
    clearAccess () {
      this.menusarr = []
      this.isCheckAll = false
    },

    /* ---------------- VALIDATE ---------------- */
    validateForm (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.updateaccess()
        }
      })
    },

    /* ---------------- SAVE ---------------- */
    updateaccess () {
      if (this.menusarr.length === 0) {
        this.$fire({
          text: 'Please Assign PDA Module Access to User',
          type: 'warning',
          timer: 3000
        })
        return
      }

      const obj = {
        sysusermasterid: this.id,
        pdabody: this.menusarr
      }

      this.$http.post(
        `${CONSTANTS.MISREPORT_API_URL}/updatePDAmoduleMenuAccess`,
        obj
      )
      .then(result => {
        if (result.body.returnmsg === 'Successful') {
          this.$fire({
            text: result.body.returnvalue,
            type: 'success',
            timer: 2000
          })

          this.$router.push('/adminuser_mr/normal');
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: 'error',
            timer: 3000
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
}
</script>